// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchArticles ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/articles`)
      .then(({ data }) => {
        commit('addArticles', data)
      })
  },
  createArticle ({ commit }, article) {
    return post('/canal/articles', article)
      .then(({ data }) => {
        commit('addArticle', data)
      })
  },
  updateArticle ({ commit }, article) {
    return put(`/canal/articles${article.id}`, article)
      .then(({ data }) => {
        commit('replaceArticle', data)
      })
  },
  createOrUpdateArticle ({ dispatch }, article) {
    if (article.id !== undefined) {
      return dispatch('updateArticle', article)
    } else {
      return dispatch('createArticle', article)
    }
  },
  selectArticle ({ commit }, article) {
    commit('setArticle', article)
  }
}
